export default __webpack_public_path__ + "static/media/KR_Text_World4.dcb213f1.svg";